import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SignInAPi } from "../../ReduxToolkit/Slice/SignIn";
import { Link, useNavigate } from "react-router-dom"; 
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Signin() {
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const status = useSelector((state) => state.signIn.status);
  const loginError = useSelector((state) => state.signIn.error);
  const notify = () =>
    toast.error(
      loginError ? loginError : "Admin not found! Please try again later"
    );
  const signinStyle = {
    position: "fixed",
    height: "100vh",
    backgroundColor: "white",
    zIndex: 99,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("")
  
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const submit = (e) => {
    e.preventDefault();
    dispatch(SignInAPi({ email, password }));
  };

  useEffect(() => {
    if (status === "failed") {
      notify();
    }
    if (status === "succeeded") {
       navigate("/");
      window.location.reload(false);
    }
  }, [status]);

  return (
    <>
      <div className="container-fluid" style={signinStyle}>
        <form action="" onSubmit={submit}>
          <div className="row">
            <div className="p-3 rounded bg-primary">
              <div className="text-center">
                <h5 className="text-white">
                  Daksh BSC Nursing Colleage <br /> & Hospital
                </h5>
              </div>
              <h2 className="text-white text-center">Login</h2>
              <div>
                <ToastContainer />
              </div>
              <div className="d-grid my-3">
                <label htmlFor="" className="text-white">
                  Email
                </label>
                <input
                  required
                  type="email"
                  className="form-control"
                  placeholder="Enter Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="d-grid my-3">
                <label htmlFor="" className="text-white">
                  Password
                </label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    required
                    className="form-control"
                    placeholder="********"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    className="btn btn-light"
                    type="button"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ?<i class="bi bi-eye-slash-fill"></i> : <i className="bi bi-eye-fill"></i> }
                  </button>
                </div>
              </div>
              <div className="d-grid">
                <button
                  className="btn btn-light"
                  type="submit"
                  disabled={status === "loading"}
                >
                  {status === "loading" ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      style={{ color: "#1976D2" }}
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Login"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default Signin;
